module.exports = __webpack_public_path__ + "img/logo.3284cc69.png";